module.exports = __webpack_public_path__ + "static/media/title-background.dca37d0f.jpg";